import React, { useMemo } from "react";
import { useSelector } from "react-redux";

function ShiftDevice({ showSubHeaders }) {
  const decimalPosition = localStorage.getItem("decimalPosition") || 2;
  const summary = useSelector(
    (state) => state.posReportshiftSlice.billTypeSummary?.device
  );

  const deviceRows = useMemo(() => (Array.isArray(summary?.list) ? summary.list.filter(Boolean) : []), [summary?.list]);

  const getAssignedNames = (items, key) =>
    (Array.isArray(items) ? items : [])
      .map((item) => item?.[key])
      .filter(Boolean)
      .join(", ") || "-";

  return (
    <div
      className="new-global-table-container"
      style={{ paddingTop: "0 42px" }}
    >
      <div className="bill-main-head">
        <h5 style={{ width: "20%" }}>Device Name</h5>
        <h5 style={{ width: "20%" }}>Employee Name</h5>
        <h5 style={{ width: "10%" }}>Order Count</h5>
        <h5 style={{ width: "17%" }}>Order Amount</h5>
        <h5 style={{ width: "17%" }}>Paid</h5>
        <h5 style={{ width: "16%" }}>Balance</h5>
      </div>

      {deviceRows.length === 0 ? (
        <div
          className="bill-sub-head"
          style={{ backgroundColor: "white", borderBottom: "1px solid black" }}
        >
          <h5>No Devices Available</h5>
        </div>
      ) : (
        deviceRows.map((device, index) => {
          if (!device || typeof device !== "object") {
            return (
              <div
                key={`device-fallback-${Math.random()}`}
                className="bill-sub-head"
                style={{ backgroundColor: "white", borderBottom: "1px solid #dcdcdc" }}
              >
                <h5 style={{ width: "15%" }}>—</h5>
                <h5 style={{ width: "15%" }}>—</h5>
                <h5 style={{ width: "15%" }}>—</h5>
                <h5 style={{ width: "10%" }}>0</h5>
                <h5 style={{ width: "15%" }}>0.00</h5>
                <h5 style={{ width: "15%" }}>0.00</h5>
                <h5 style={{ width: "15%" }}>0.00</h5>
              </div>
            );
          }

          // Get actual employees who took orders (from employees array)
          const actualEmployees = getAssignedNames(
            device?.employees,
            "employeeName"
          );
          const assignedCategories = getAssignedNames(
            device?.assignedCategories,
            "categoryName"
          );

          return (
            <React.Fragment key={device?.deviceId || device?.deviceCode || device?.deviceName || `device-${index}`}>
              <div
                className="bill-sub-head"
                style={{ backgroundColor: "white", borderBottom: "1px solid #dcdcdc" }}
              >
                <h5 style={{ width: "20%" }}>
                  {device?.deviceName || "Unassigned Device"}
                  {device?.deviceCode ? (
                    <span style={{ display: "block", fontSize: 12, color: "#616161" }}>
                      Code: {device.deviceCode}
                    </span>
                  ) : null}
                </h5>
                <h5 style={{ width: "20%" }}>{actualEmployees}</h5>
                <h5 style={{ width: "10%" }}>{device?.count || 0}</h5>
                <h5 style={{ width: "17%" }}>{(device?.amount || 0).toFixed(decimalPosition)}</h5>
                <h5 style={{ width: "17%" }}>{(device?.paidAmount || 0).toFixed(decimalPosition)}</h5>
                <h5 style={{ width: "16%" }}>{(device?.balanceAmount || 0).toFixed(decimalPosition)}</h5>
              </div>

              {showSubHeaders && (
                <div style={{ backgroundColor: "#fafafa", borderBottom: "1px solid #dcdcdc" }}>
                  {/* Category-wise Sales */}
                  {Array.isArray(device?.categorySales) && device.categorySales.length > 0 && (
                    <div style={{ marginBottom: "8px" }}>
                      <div className="bill-main-head" style={{ backgroundColor: "#e3f2fd" }}>
                        <h5 style={{ width: "60%", fontWeight: "600", paddingLeft: "20px" }}>Category</h5>
                        <h5 style={{ width: "40%", fontWeight: "600", textAlign: "right", paddingRight: "20px" }}>Sales Amount</h5>
                      </div>
                      {device.categorySales.map((cat, idx) => (
                        <div
                          className="bill-sub-head"
                          style={{ 
                            backgroundColor: idx % 2 === 0 ? "#ffffff" : "#f5f5f5",
                            borderBottom: "1px solid #e0e0e0"
                          }}
                          key={(cat?.categoryId || cat?.categoryName || idx) + "-cat"}
                        >
                          <h5 style={{ width: "60%", fontSize: "13px", paddingLeft: "20px" }}>{cat?.categoryName || "Uncategorized"}</h5>
                          <h5 style={{ width: "40%", fontSize: "13px", textAlign: "right", paddingRight: "20px" }}>{(cat?.amount || 0).toFixed(decimalPosition)}</h5>
                        </div>
                      ))}
                    </div>
                  )}

                  {/* Order Type Breakdown */}
                  {(device?.orderTypeBreakdown?.diningCount > 0 || 
                    device?.orderTypeBreakdown?.takeawayCount > 0 || 
                    device?.orderTypeBreakdown?.deliveryCount > 0) && (
                    <div>
                      <div className="bill-main-head" style={{ backgroundColor: "#fff3e0" }}>
                        <h5 style={{ width: "33.33%", fontWeight: "600", textAlign: "center" }}>Dining</h5>
                        <h5 style={{ width: "33.33%", fontWeight: "600", textAlign: "center" }}>Takeaway</h5>
                        <h5 style={{ width: "33.34%", fontWeight: "600", textAlign: "center" }}>Delivery Partner</h5>
                      </div>
                      <div
                        className="bill-sub-head"
                        style={{ 
                          backgroundColor: "#ffffff",
                          borderBottom: "1px solid #e0e0e0"
                        }}
                      >
                        <h5 style={{ width: "33.33%", fontSize: "14px", fontWeight: "500", textAlign: "center" }}>
                          {device?.orderTypeBreakdown?.diningCount || 0}
                        </h5>
                        <h5 style={{ width: "33.33%", fontSize: "14px", fontWeight: "500", textAlign: "center" }}>
                          {device?.orderTypeBreakdown?.takeawayCount || 0}
                        </h5>
                        <h5 style={{ width: "33.34%", fontSize: "14px", fontWeight: "500", textAlign: "center" }}>
                          {device?.orderTypeBreakdown?.deliveryCount || 0}
                        </h5>
                      </div>
                    </div>
                  )}
                </div>
              )}
            </React.Fragment>
          );
        })
      )}

      <div className="bill-main-head" style={{ backgroundColor: "white" }}>
        <h5 style={{ width: "20%" }}>All Devices</h5>
        <h5 style={{ width: "20%" }}>—</h5>
        <h5 style={{ width: "10%" }}>{summary?.count || 0}</h5>
        <h5 style={{ width: "17%" }}>{(summary?.total || 0).toFixed(decimalPosition)}</h5>
        <h5 style={{ width: "17%" }}>{(summary?.totalPaid || 0).toFixed(decimalPosition)}</h5>
        <h5 style={{ width: "15%" }}>{(summary?.totalBalance || 0).toFixed(decimalPosition)}</h5>
      </div>
    </div>
  );
}

export default ShiftDevice;